import React, { useEffect } from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { CTSUCardActions } from 'components';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';
import { withAppContext } from '@ctsu/loader';
import { compose, withState, withHandlers } from 'recompose';
import { MUITextBox, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum } from 'appconstants';
import atoms from 'ctsutheme/components/atoms';
import { openConfirmation } from 'helpers/Confirmation';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { getEmptyValue } from 'helpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindLogger } from 'helpers/BindLogger';
import PropTypes from 'prop-types';
import { saveComments } from 'actions/protocols/protocoldetail';
import { CanUserEditIternalComments } from 'appconstants/Permission';

const { Divider } = atoms;

const styles = theme => ({
  editable: {
    // width: 70
  }
});

const useStyles = makeStyles(theme => ({
  internalCommentsContent: {
    overflowWrap: 'anywhere',
    overflow: 'hidden'
  }
}));

const InternalComments = ({
  comments,
  state,
  setState,
  setData,
  data,
  handleChange,
  clearInternalComments,
  closeInternalComments,
  saveInternalComments,
  classes
}) => {
  const commentClasses = useStyles();
  useEffect(() => {
    setData({
        comments
    });
  }, [setData, comments]);
  return (
    <RenderEditable
      state={state}
      editable={CanUserEditIternalComments()}
      setState={setState}
      title="Internal Comments"
    >
      <RenderElement access={state === false}>
        <>
          <FormViewContent
            name="comments"
            // more
            primaryText="Internal Comments"
            secondaryClassName={commentClasses.internalCommentsContent}
            secondaryText={getEmptyValue(`${data.comments}`)}
          />
        </>
      </RenderElement>
      <RenderElement access={state === true}>
        <ValidatorForm onSubmit={saveInternalComments}>
          <FormViewContent
            primaryText="Internal Comments"
            secondaryText={(
              <MUITextBox
                title="Internal Comments"
                multiline
                rowsMax="4"
                onChange={handleChange}
                name="comments"
                validators={['maxStringLength:500']}
                errorMessages={['Maximum 500 characters allowed']}
                value={getEmptyValue(data.comments)}
                placeholder="Comment"
              />
            )}
          />
          <Divider />
          <CTSUCardActions
            clearClick={clearInternalComments}
            cancelClick={closeInternalComments}
            disabled={data.comments === comments}
          />
        </ValidatorForm>
      </RenderElement>
    </RenderEditable>
  );
};


InternalComments.propTypes = {
  comments: PropTypes.string,
  state: PropTypes.bool,
  setState: PropTypes.func,
  setData: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.object]),
  handleChange: PropTypes.func,
  clearInternalComments: PropTypes.func,
  closeInternalComments: PropTypes.func,
  saveInternalComments: PropTypes.func,
  classes: PropTypes.oneOfType([PropTypes.object])
};

InternalComments.defaultProps = {
  comments: null,
  state: false,
  setState: null,
  setData: null,
  data: null,
  handleChange: null,
  clearInternalComments: null,
  closeInternalComments: null,
  saveInternalComments: null,
  classes: null
};

const withConnectState = connect(
  (state, ownProps) => ({
    prtInfo: state.prtDetails.prtInfo
  }),
  dispatch => bindActionCreators(
    {
      onSaveInternalComments: saveComments
    },
    dispatch
  )
);

export default withStyles(styles)(compose(
  withConnectState,
  withAppContext,
  withState('state', 'setState', false),
  withState('data', 'setData', {}),
  withHandlers({
    closeInternalComments: props => event => {
      const { setState, setData, comments, state } = props;
      setData({ comments });
      setState(!state);
    }
  }),
  withHandlers({
    handleChange: props => event => {
      const { data, setData } = props;
      setData({ ...data, [event.target.name]: event.target.value });
    },
    clearInternalComments: props => event => {
      const { setData, comments } = props;
      setData({ comments });
    },
    saveInternalComments: props => event => {
      const {
        context,
        onSaveInternalComments,
        data,
        prtInfo,
        closeInternalComments
      } = props;
      const confirmEdit = () => {
        bindLogger(onSaveInternalComments, context)(data, prtInfo.prtId).subscribe(
          resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
              openSnackbar({
                message: "Internal comments saved successfully", // GetFromCtxValue(context, 'PROTOCOL_COLLECT_IRB_SUCCESS')
                variant: 'success',
                name: 'internal_comments'
              });
              closeInternalComments();
            }
          },
          err => {}
        );
      };
      openConfirmation({
        message:  'Do you want to save Internal Comments?', // GetFromCtxValue(context, 'PROTOCOL_COLLECT_IRB_CONFIMATION'),
        onAction: confirmEdit,
        name: 'internal_comments'
      });
    }
  })
)(InternalComments));
